import { useEffect, useState } from "react";
import { readWorkCenterJson } from "./workCenterApi";
import { WorkCenterApiFetch } from "./workCenterTaskTypes";

export type MasterDataValue = {
  code: string;
  name: string;
  description: string;
  category?: "EXTRACT" | "TRANSFORM" | "LOAD" | "CONSUME";
  sortOrder: number;
  isActive: boolean;
};

export type WorkCenterMasterData = {
  topics: MasterDataValue[];
  entities: MasterDataValue[];
  departments: MasterDataValue[];
  systems: MasterDataValue[];
  tools: MasterDataValue[];
  systemTypes: MasterDataValue[];
  suppliers: MasterDataValue[];
  initiativeTypes: MasterDataValue[];
  taskTypes: MasterDataValue[];
  initiativeStatuses: MasterDataValue[];
  taskStatuses: MasterDataValue[];
  priorities: MasterDataValue[];
  benefitTypes: MasterDataValue[];
};

export const emptyWorkCenterMasterData: WorkCenterMasterData = {
  topics: [], entities: [], departments: [], systems: [], tools: [], systemTypes: [], suppliers: [],
  initiativeTypes: [], taskTypes: [], initiativeStatuses: [], taskStatuses: [], priorities: [], benefitTypes: [],
};

export function useWorkCenterMasterData(apiFetch: WorkCenterApiFetch) {
  const [data, setData] = useState(emptyWorkCenterMasterData);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let active = true;
    Promise.all((["topics", "entities", "departments", "systems", "tools", "systemTypes", "suppliers", "initiativeTypes", "taskTypes", "initiativeStatuses", "taskStatuses", "priorities", "benefitTypes"] as const).map(async (type) => {
      const response = await apiFetch(`/api/admin/workcenter/master-data?type=${type}`);
      const body = await readWorkCenterJson(response);
      return [type, body.items || []] as const;
    })).then((entries) => {
      if (!active) return;
      setData(Object.fromEntries(entries) as WorkCenterMasterData);
      setError("");
    }).catch((loadError) => {
      if (active) setError(loadError instanceof Error ? loadError.message : "Keuzelijsten laden mislukt.");
    });
    return () => { active = false; };
  }, [apiFetch, reload]);

  return { data, error, retry: () => setReload((value) => value + 1) };
}
